// ASCII Art and visual elements
export const ASCII_ART = {
    welcome: `                                             
    Welcome to Abdulrahman's Portfolio Terminal v1.0       
                                                        
    Type 'help' to see available commands                  
    Press '~' or click the terminal icon to toggle         
                                                        
`,

    coffee: `
      ( (
       ) )
    ........
    |      |]
    \\      /
     \`----'
  ☕ Coffee break!
`,

    hack: `
    [████████████] 100%
    Accessing mainframe...
    Bypassing firewall...
    Just kidding! This is a portfolio 😄
`,

    matrix: `
    Wake up, Neo...
    The Matrix has you...
    Follow the white rabbit.
    
    Knock, knock.
`
};

export const JOKES = [
    "Why do programmers prefer dark mode? Because light attracts bugs! 🐛",
    "How many programmers does it take to change a light bulb? None, that's a hardware problem! 💡",
    "Why do Java developers wear glasses? Because they can't C# 👓",
    "A SQL query walks into a bar, walks up to two tables and asks... 'Can I JOIN you?' 🍺",
    "!false - It's funny because it's true! 😄",
    "Why did the developer go broke? Because he used up all his cache! 💸",
    "There are 10 types of people: those who understand binary and those who don't. 🔢",
    "Programming is 10% writing code and 90% understanding why it doesn't work. 🤔"
];

export const QUOTES = [
    "\"Code is like humor. When you have to explain it, it's bad.\" - Cory House",
    "\"First, solve the problem. Then, write the code.\" - John Johnson",
    "\"Experience is the name everyone gives to their mistakes.\" - Oscar Wilde",
    "\"The best error message is the one that never shows up.\" - Thomas Fuchs",
    "\"Simplicity is the soul of efficiency.\" - Austin Freeman",
    "\"Make it work, make it right, make it fast.\" - Kent Beck",
    "\"Clean code always looks like it was written by someone who cares.\" - Robert C. Martin"
];

const asciiArtExports = { ASCII_ART, JOKES, QUOTES };

export default asciiArtExports;
